var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS2B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 51C39.5833 51 51 39.5833 51 25.5C51 11.4167 39.5833 0 25.5 0C11.4167 0 0 11.4167 0 25.5C0 39.5833 11.4167 51 25.5 51Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1079 38.7876C36.0442 38.534 34.4532 32.584 25.5042 32.584C16.5537 32.584 14.9642 38.534 14.9004 38.7876C14.8225 39.095 14.9613 39.4137 15.2362 39.5724C15.5124 39.7297 15.8581 39.6829 16.0862 39.4633C16.1131 39.4364 18.8543 36.834 25.5042 36.834C32.154 36.834 34.8967 39.4364 34.9222 39.4619C35.0582 39.5965 35.2395 39.6673 35.4208 39.6673C35.5398 39.6673 35.6602 39.6376 35.7693 39.5767C36.047 39.418 36.1858 39.0964 36.1079 38.7876Z",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0026 24.0837C18.9586 24.0837 20.5443 21.8637 20.5443 19.1253C20.5443 16.3869 18.9586 14.167 17.0026 14.167C15.0466 14.167 13.4609 16.3869 13.4609 19.1253C13.4609 21.8637 15.0466 24.0837 17.0026 24.0837Z",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0046 24.0837C35.9606 24.0837 37.5462 21.8637 37.5462 19.1253C37.5462 16.3869 35.9606 14.167 34.0046 14.167C32.0485 14.167 30.4629 16.3869 30.4629 19.1253C30.4629 21.8637 32.0485 24.0837 34.0046 24.0837Z",
    fill: "#664500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2B);
export default __webpack_public_path__ + "static/media/s2b.8f278578ea10ef039d27be6113910673.svg";
export { ForwardRef as ReactComponent };